export default __webpack_public_path__ + "08c62bd84ba7df0dcc5cd2052d4e0dff.svg";